import { Component, OnInit } from '@angular/core';
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';
import { Router, ActivatedRoute } from '@angular/router';
import { loginmodel } from '../../models/login/login.model';
import * as CryptoJS from 'crypto-js';
import { AppSettings } from '../../config/settings/app-settings';


@Component({
	selector: 'app-login',
	templateUrl: './login.component.html'
})
export class loginComponent implements OnInit {

	public errorMsg: string = "";
	public successMsg: string = "";
	public sessionData: any;
	public loginmodel: loginmodel = new loginmodel;
	public allUserData: any = [];
	public loggedInUserData: any = "";
	public viewpopupopen: boolean = false;
	public otpSend: boolean = false;
	public sendOtpResponeData: any = "";
	public validateOtpResponeData: any = "";
	public forgotresponse: any = "";
	public isHidePrepaid : boolean = true;
	public serviceOn : boolean = false;

	constructor(
		public http: HttpTestService, 
		public session: sessionServices,
		public router: Router) {}

	ngOnInit() {
		this.getSession();
	}	

	getSession = function () {
		this.sessionData = this.session.getSessionDetails();
	}

	openPopup = function () {
		var self = this;
		self.loginmodel.forgotConsumer = "";
		self.viewpopupopen = true;
		self.errorMsg = "";
		self.successMsg = "";
	}

	closePopup = function () {
		var self = this;
		self.viewpopupopen = false;
		self.loginmodel.forgotConsumer = "";
	}

	sendOTP = function () {
		var self = this;
		self.otpSend = false;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = self.loginmodel.consumerId;
		self.http.sendOTP(requestedConsumer).subscribe(
			(data) => {
				self.sendOtpResponeData = data;
			},
			(error) => {
				self.errorMsg = error;
				self.sendOtpResponeData = "";
			},
			() => {
				if (self.sendOtpResponeData) {
					self.otpSend = true;
				}

			}
		);
	}

	validateOTP = function () {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = self.loginmodel.consumerId;
		var requestedOtp = self.loginmodel.consumerOtp;

		self.http.validateOTP(requestedConsumer + "^" + requestedOtp).subscribe(
			(data) => {
				self.validateOtpResponeData = data;
			},
			(error) => {
				self.errorMsg = error;
				self.validateOtpResponeData = "";
			},
			() => {
				if (self.validateOtpResponeData) {
					self.getConsumerDetails(self.loginmodel.consumerId);
				} else {
						self.errorMsg = "OTP mismatched. Please enter the right OTP.";
				}
			}
		);
	}

	onSelectPayment(selectedID){
		if(selectedID == 1)
			this.isHidePrepaid = false;
		else
			this.isHidePrepaid = true;
	}

	closePopups(){
		this.loginmodel.paymentMode="";
		this.isHidePrepaid = true;
	}
//----------This function is used for login purpose-----------//
	authenticateUser = function () {
		var self = this;
		self.serviceOn = true;
		// let param = {
		// 	consumerId:self.loginmodel.consumerId,
		// 	password:self.loginmodel.SignInPass
		// }
		let body = new URLSearchParams();
        body.set('consumerId', this.loginmodel.consumerId);
        body.set('password', this.loginmodel.SignInPass);

		self.http.newAuthenticateUser(body.toString()).subscribe(
			(data) => {
				self.authUser = data;
				this.http.userLoggedIn.emit();
				this.http.getConsumerDetailsfromService(self.loginmodel.consumerId);
			},
			(error) => {
				self.errorMsg = "Some error occurred!";
				self.authUser = error;
				self.serviceOn = false;
			},
			() => {
				console.log("Login response: ", self.authUser)
				if (self.authUser['responseStatus'] === 0) {
					self.errorMsg = "Please use a valid credential!";
					self.serviceOn = false;
				} else if(self.authUser['responseStatus'] === 1) {
					self.getConsumerDetails(self.loginmodel.consumerId);
				} else if(self.authUser.status === 2){//GAYA_CONSUMER_NOT_AVAILABLE
					self.errorMsg = "Service is not available for this number range!";
					self.serviceOn = false;
				}
			}
		);
	}
//----------------End of  login purpose----------------------//
	getConsumerDetails = function (requestedConsumer) {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
       
		self.http.getConsumerInfoByConsumerId(requestedConsumer).subscribe(
			(data) => {
				self.loggedInUserData = data;
				console.log("***********Login Data:1 ", self.loggedInUserData)
			},
			(error) => {
				self.errorMsg = error;
				self.loggedInUserData = "";
				self.serviceOn = false;
				console.log("***********Login Data:2 ", self.loggedInUserData)
			},
			() => {
				console.log("***********Login Data:3 ", self.loggedInUserData)
			if (self.loggedInUserData.name && self.loggedInUserData.registered) {
				console.log("***********Login Data:4 ", self.loggedInUserData)
				var key = AppSettings.SEC_KEY_ID_1;
				var iv = AppSettings.SEC_KEY_ID_2;
				var sessionKey = AppSettings.SEC_KEY_ID_1 + "true!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.name + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.emailid + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.region + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.businessAreaText + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.consumerNo + "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loginmodel.SignInPass
								+ "!^@#" + AppSettings.SEC_KEY_ID_1 + self.loggedInUserData.mobileNo;
				// var sessionKey = AppSettings.SEC_KEY_ID_1 + "true!^@#" + AppSettings.SEC_KEY_ID_1 + "ASANSOL ENGG. COLLEGE" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "principal.aecwb@gmail.com" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "ASANSOL-DPS" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "DPS" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "3100160" + "!^@#" + AppSettings.SEC_KEY_ID_1 + "self.loginmodel.SignInPass";
				var encrypted: any = CryptoJS.AES.encrypt(sessionKey, key, { iv: iv });
				encrypted = (encrypted).toString();
				window.sessionStorage.setItem('sessionKey', encrypted);
				//this.router.navigate(['/dashboardCat'], { skipLocationChange: false });
				self.serviceOn = false;
				window.location.replace('');	
			} else if((self.loggedInUserData.status === 'Failure') && !(self.loggedInUserData.registered)){
				console.log("***********Login Data:5 ", self.loggedInUserData)
				self.serviceOn = false;
				self.errorMsg = "Sorry! There is some technical problem. Please try later.";
			}
			
		});
	}

	resetForm = function () {
		var self = this;
		self.loginmodel.consumerId = "";
		self.loginmodel.SignInPass = "";
		self.loginmodel.consumerOtp = "";
		self.otpSend = false;
	}

	forgotPass = function () {
		var self = this;

		self.http.forgotPassword(self.loginmodel.forgotConsumer).subscribe(
			(data) => {
				self.forgotresponse = data;
			},
			(error) => {
				self.errorMsg = error;
				self.forgotresponse = "";
			},
			() => {
				self.closePopup();
				if (self.forgotresponse) 
					self.successMsg = "Please check your registered email for password reset instructions";
				else 
					self.errorMsg = "We are unable to process your request.";	
			}
		);
	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/login/login.component.ts